import axios from "axios";
import {ordersServicesPath} from "../../../Constants";

const jobRestUrl = ordersServicesPath + '/organizations/jobs'

export default class JobService {

    static async getJobsByOrderId(id) {
        return axios.get(jobRestUrl + '/' + id);
    }

    static async getJobsByEstimateId(estimateId) {
        return axios.get(jobRestUrl + '/estimate/' + estimateId);
    }

    static async delete(id) {
        return await axios.delete(jobRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableWorkerByJobsId(id, workerId, status) {
        return axios.patch(jobRestUrl + '/' + id + '?workerId=' + workerId + '&status=' + status, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async executeJob(id, date) {
        return axios.patch(jobRestUrl + '/' + id + '/execute', JSON.stringify(date), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async closeExecuteJob(id) {
        return axios.patch(jobRestUrl + '/cancellation/' + id, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}